import { vec3 } from "gl-matrix";

export const axis = [
    vec3.fromValues(1, 0, 0),
    vec3.fromValues(0, 1, 0),
    vec3.fromValues(0, 0, 1),
    vec3.fromValues(1, 0, 0),
    vec3.fromValues(0, 1, 0),
    vec3.fromValues(0, 0, 1),
];
export const xAxis = vec3.fromValues(1, 0, 0);
export const yAxis = vec3.fromValues(0, 1, 0);
export const MAX_FLOAT = 3.4028234663852886e38;
